import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useThemeStore } from "../../store/useThemeStore";
import { useAuthStore } from "../../store/useAuthStore";
import { Header } from "../layouts/Header";
import { EnvioDocumentosUploader } from "../shared/EnvioDocumentosUploader";

export default function SolicitarRecalculoView() {
  const { processoId } = useParams();
  const loadTheme = useThemeStore((s) => s.loadTheme);
  const theme = useThemeStore((s) => s.theme);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const logout = useAuthStore((s) => s.logout);

  useEffect(() => {
    loadTheme(null);
  }, [loadTheme]);

  useEffect(() => {
    const prev = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "#F9FAFB";
    return () => { document.body.style.backgroundColor = prev; };
  }, []);

  return (
    <div className="min-h-screen flex flex-col" style={{ overscrollBehavior: "contain" }}>
      <Header isLoggedIn={isAuthenticated} onLogout={logout} />
      <main className="flex flex-col flex-1 bg-muted">
        <div className="flex flex-1 items-start sm:items-center justify-center p-4 pt-8 sm:pt-4">
          <div className="w-full max-w-lg bg-card rounded-xl shadow-md p-5 sm:p-8">
            {theme?.logo_url && (
              <img src={theme.logo_url} alt="Logo" className="h-10 sm:h-12 mx-auto mb-5 sm:mb-6 object-contain" />
            )}
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">Enviar Documentos</h1>
            <p className="text-muted-foreground text-sm mb-5 sm:mb-6 leading-relaxed">
              Preencha seus dados e envie os documentos necessários.
            </p>
            <EnvioDocumentosUploader processoId={processoId} />
          </div>
        </div>
      </main>
      <footer
        className="text-center p-4 text-sm border-t border-border"
        style={{ backgroundColor: "var(--footer-bg, #ffffff)", color: "var(--footer-fg, #64748b)" }}
      >
        © 2026 Juri Ativos Judiciais. Todos os direitos reservados.
      </footer>
    </div>
  );
}
